import StopHandlingCell from './component';
import { compose } from 'recompose';
import { connect } from 'react-redux';

import { withJourneyCardSelectors } from 'modules/journey/card/hoc';

const fields = ['extras'];

const enhance = compose(
  withJourneyCardSelectors,
  connect((state, props) => {
    const { extras } = props.selectors.getJourneyStopFields(
      state,
      props.journeyId,
      props.stopId,
      fields
    );
    return {
      showIcon: extras.includes('HANDLING_LOADING') || extras.includes('HANDLING_UNLOADING'),
    };
  })
);

export default enhance(StopHandlingCell);
